import { useState } from "react";
import { Clock, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";

export default function PendingAccess() {
  const { user, logout } = useAuth();
  const [busy, setBusy] = useState(false);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDFDFD] p-6" data-testid="pending-access-page">
      <div className="w-full max-w-md rounded-md border border-[#E5E7EB] bg-white p-8 text-center">
        <div className="flex justify-center"><Logo /></div>
        <Clock className="h-8 w-8 text-[#FCC419] mx-auto mt-6" />
        <h1 className="font-heading text-xl font-bold text-[#111827] mt-4">Awaiting activation</h1>
        <p className="text-sm text-[#6B7280] mt-3">
          Your account <b className="text-[#111827]">{user?.email}</b> has been created but is not active yet.
          A LabTrack administrator must approve your access before you can use the laboratory records.
        </p>
        <p className="text-sm text-[#6B7280] mt-3">
          Need it sooner? Write to{" "}
          <a href="mailto:info@pathlete.org" className="text-[#002FA7] hover:underline">info@pathlete.org</a>.
        </p>
        <Button variant="outline" className="mt-6" data-testid="pending-logout-btn" disabled={busy}
          onClick={async () => { setBusy(true); await logout(); window.location.href = "/"; }}>
          <LogOut className="h-4 w-4 mr-2" /> Sign out
        </Button>
      </div>
    </div>
  );
}
